<div class="row">
    <div class="col-md-6 p-0">
        <app-grid [columns]="columns" [rows]="data.tableRows" [tableParams]="data.tableParams" [multiSelect]="false"
            (refreshDataFromServer)="refreshData($event)" (rowSelected)="rowSelecetedEvent($event)"
            [gridName]="'questionCategoryGrid'" (addClicked)="addCategory()" #gridComponent
            (deleteClicked)="deleteCategory()"></app-grid>
    </div>
    <div class="col-md-6 p-0 card">
        <div class="">
            <div class="p-4 mr-0 p-gutter ">
                <h5>{{text}} Category</h5>
                <form class="mr-0 d-flex flex-column align-items-center" (ngSubmit)="submitCategory()">
                    <div class="mb-3 mr-0 col-md-10">
                        <label class="form-label">Category</label>
                        <input type="text" class="form-control" [(ngModel)]="selectedCategory.category"
                            [ngModelOptions]="{ standalone: true }">
                    </div>

                    <div class="mb-3 mr-0 col-md-10">
                        <label class="form-label">Description</label>
                        <textarea type="text" class="form-control" [(ngModel)]="selectedCategory.description"
                            [ngModelOptions]="{ standalone: true }"></textarea>
                    </div>

                    <button class="btn btn-primary btn-lg col-md-10" type="submit">Save</button>
                </form>
            </div>

        </div>

    </div>
</div>